import HomeSwap from './components/Swap'

export default function HomeTwoPage() {
	return (
		<div className="pt-[1.625rem]">
			<HomeSwap />
		</div>
	)
}
